// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overlay[data-v-22231a0f]{position:fixed;top:0;right:0;bottom:0;left:0;z-index:10;overflow:hidden;background-color:var(--general-bg-backdrop)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
